'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { getLegacyHistory } from '#pplx/frontend/router/legacyHistory.js';
import { createNavigationGuards } from '#pplx/frontend/router/navigationGuard.js';
import { initRouterStartTimeUpdater, RouterContext, routerStartTimeFromTimeOriginRef, } from '#pplx/frontend/router/RouterContext.js';
import React, { useState } from 'react';
export const RouterProvider = React.memo(function RouterProvider({ spaRoutes, openNonSpaRouteInNewTab, appRef, children, }) {
    initRouterStartTimeUpdater();
    getLegacyHistory();
    const [navigationGuards] = useState(createNavigationGuards);
    return (_jsx(RouterContext.Provider, { value: {
            navigationGuards,
            spaRoutes,
            openNonSpaRouteInNewTab,
            startTimeFromTimeOriginRef: routerStartTimeFromTimeOriginRef,
            appRef,
        }, children: children }));
});
//# sourceMappingURL=RouterProvider.js.map